<script setup>
import { computed, watch, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useAuthStore } from '@/store/auth';
import SidenavItem from "./SidenavItem.vue";

const authStore = useAuthStore();
const store = useStore();
const router = useRouter();
const isRTL = computed(() => store.state.isRTL);
const viewUpload = ref();

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};

watch(
  () => authStore.infoAcces,
  (newVal) => {
    if (newVal && newVal.upload !== undefined) {
      viewUpload.value = newVal.upload;
    }
  },
  { immediate: true }
);
const loginAuth = async()=>{

const result = await authStore.logout( {
    token: localStorage.getItem('token'),
    _id: authStore.infoAcces.id
  });
if(result.ok){
  localStorage.clear()
    router.push('/');
  } 
};

</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/dashboard"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
          navText="Información/Reportes"
        >
          <template v-slot:icon>
            <i class="ni ni-collection text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item"  v-if="viewUpload">
        <sidenav-item
          to="/documentos"
          :class="getRoute() === 'documentos' ? 'active' : ''"
          navText="Carga de Información"
        >
          <template v-slot:icon>
            
            <i class="ni ni-single-copy-04 text-primary text-sm opacity-10"></i>
            
          </template>
        </sidenav-item>
      </li> 

      <!-- <li class="nav-item">
        <sidenav-item
          to="/billing"
          :class="getRoute() === 'billing' ? 'active' : ''"
          :navText="isRTL ? 'الفواتیر' : 'Sis@doc'"
        >
          <template v-slot:icon>
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <!-- <li class="nav-item">
        <sidenav-item
          to="/virtual-reality"
          :class="getRoute() === 'virtual-reality' ? 'active' : ''"
          :navText="isRTL ? 'الواقع الافتراضي' : 'Cartera'"
        >
          <template v-slot:icon>
            <i class="ni ni-app text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <!-- <li class="nav-item">
        <sidenav-item
          to="/rtl-page"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="Reportes"
        >
          <template v-slot:icon>
            <i class="ni ni-world-2 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <li class="mt-3 nav-item">
        <h6
          v-if="isRTL"
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'"
        >
          صفحات المرافق
        </h6>

        <h6
          v-else
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'"
        >
          Mi cuenta
        </h6>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/perfil"
          :class="getRoute() === 'perfil' ? 'active' : ''"
          :navText="isRTL ? 'حساب تعريفي' : 'Perfil'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <!-- <li class="nav-item">
        <sidenav-item
          to="/signin"
          :class="getRoute() === 'signin' ? 'active' : ''"
          :navText="isRTL ? 'تسجيل الدخول' : ''"
        >
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <li class="nav-item">
        <sidenav-item
          to="/"
          :class="getRoute() === 'signup' ? 'active' : ''"
          navText="Cerrar sesión"
          @click="loginAuth"
        >
          <template v-slot:icon>
            <i class="ni ni-button-power text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
</template>
